import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";

let _this =  {

	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
		video: $('.franli-module-single-product-hero__popup video')
    },

    vars: {
	},

	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {
		Fancybox.bind("[data-fancybox]", {
			on: {
			  close: (fancybox, key) => {
				if(_this.$dom.video.length !== 0) {
					_this.$dom.video[0].currentTime = 0;
					_this.$dom.video[0].pause();
				}
			  },
			},
		  });
		Fancybox.bind("a[href='#get-in-touch']", {

		});
    },

};

export default _this;